import * as PageResponsive from "components/utility/page-responsive/PageResponsive";

// This function counts each card taking into account if that card is a description card
const cardCounter = (cards, columns, cardType) => {
	let count = 0;
	var descClass =
		cardType === "utility"
			? "collection-card-utility-description"
			: "collection-page-card-description";
	var cardClass = cardType === "utility" ? "collection-card-utility" : "collection-page-card";

	cards.forEach((card) => {
		if (card.classList.contains(descClass)) {
			if (card.classList.contains("col_md-4_sm-12") && columns !== 2) {
				count++;
			} else {
				count += 2;
			}
		} else if (card.classList.contains(cardClass)) {
			count++;
		}
	});

	return count;
};

// This function sets the card type and creates a card array with utility or page-card cards
const cardSorter = (collection) => {
	let cards = [
		...collection.querySelectorAll(".collection-card-utility-description"),
		...collection.querySelectorAll(".collection-card-utility"),
	];
	let cardType = "utility";
	if (cards.length === 0) {
		cards = [
			...collection.querySelectorAll(".collection-page-card-description"),
			...collection.querySelectorAll(".collection-page-card"),
		];
		cardType = "default";
	}
	return { cards, cardType };
};

// This function decides if an empty collection card is going to be added for representing the right border of the last actual collection card
export const collectionPageGridline = async () => {
	var onResize = function () {
		document.querySelectorAll(".content-card-last").forEach((card) => {
			card.remove();
		});

		if (!PageResponsive.isMobile()) {
			let columns;

			if (PageResponsive.isContentMax()) columns = 4;
			else if (PageResponsive.isDesktop()) columns = 3;
			else if (PageResponsive.isTablet()) columns = 2;

			document.querySelectorAll(".collection-page-section").forEach((collection) => {
				const { cards, cardType } = cardSorter(collection);
				if (cards.length) {
					const count = cardCounter(cards, columns, cardType);
					if (count % columns !== 0) {
						const lastCard = cards.pop();
						const emptyCard = document.createElement("div");
						emptyCard.classList.add(
							"col_md-4_sm-12",
							"collection-card-utility-description",
							"content-card-last"
						);
						lastCard.parentNode.appendChild(emptyCard);
					}
				}
			});
		}
	};

	onResize();
	window.addEventListener("resize", onResize);
};
